// Centralized customer-facing TRUST claims — single source of truth.
//
// RULES (do not violate):
//  - Only owner-confirmed claims live here. Nothing else may be shown to customers.
//  - Any value that is NOT yet owner-confirmed is `null` and MUST be render-gated
//    (render the line only when the value is non-null). Never fabricate a number.
//  - No GSTIN anywhere — GST registration differs per city. "GST invoice" stays
//    true because a GST tax-invoice is genuinely issued; the number is never shown.
//  - Starting prices reuse the already-published site values (existing data).

// The headline promise — RNR's structural amazingness.
export const HEADLINE = 'A mechanic reaches you in 30 minutes';
export const HEADLINE_SUB =
  'Repaired in front of you — pay only what you approve.';

// Aggregate social proof (already live on the homepage hero).
export const SOCIAL_PROOF = {
  customers: '2,00,000+',
  rating: '4.8',
  cities: '32+',
};

// Already-published starting prices (existing site data — not new).
export const STARTING_PRICE = {
  bike: 450,
  car: 999,
};

// Warranty — owner-confirmed scope and claim path.
export const WARRANTY = {
  serviceDays: 30, // confirmed
  engineMonths: 6, // confirmed
  claimPath: [
    'Report the issue to us',
    'We re-inspect free of charge',
    'We re-do the work or refund you',
  ],
  // NOT owner-confirmed yet — render only if/when supplied. Never invent.
  exclusions: null,
};

// Mechanic vetting — state ONLY the steps actually performed; no fabricated
// minimum-experience year count (render `minExperienceYears` only if supplied).
export const MECHANIC_VETTING = {
  steps: [
    'Government ID verified',
    'Address verified',
    'Skill assessment passed',
    'Experienced & verified',
  ],
  minExperienceYears: null, // NOT owner-confirmed — never fabricate.
};

// The doorstep guarantee — RNR's edge over the garage model.
export const DOORSTEP_GUARANTEE = [
  'Repaired in front of you',
  'Written estimate shared & confirmed before final work',
  'Nothing extra without your approval',
  'Pay only what you approved',
];

// Parts & invoice.
export const PARTS_AND_INVOICE = {
  genuinePartsOnly: 'Genuine spare parts only',
  gstInvoice: 'GST invoice on every service',
};

// Payment security + accountability. Grievance SLA is NOT owner-confirmed —
// render the SLA phrase only when `grievanceSlaText` is supplied.
export const PAYMENT_SECURITY = {
  methods: 'Secure payments via Razorpay / UPI',
  grievance: 'Published grievance & escalation path',
  grievanceSlaText: null, // NOT owner-confirmed — never fabricate.
  vehicleSecurity:
    'Your vehicle is 100% secure with us — any and every issue handled end to end',
};

// Suggested (advisory, never contractual) next-service interval, in days,
// used by the Passport to phrase a soft reminder. Conservative defaults.
export const NEXT_SERVICE_SUGGEST_DAYS = {
  default: 120,
  full_service: 120,
};

// Convenience: the compact trust-strip items reused across surfaces.
export const TRUST_STRIP = [
  `${SOCIAL_PROOF.customers} customers`,
  `${SOCIAL_PROOF.rating}★ rated`,
  `${SOCIAL_PROOF.cities} cities`,
  `${WARRANTY.serviceDays}-day warranty`,
];
